'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ro_RO = require('../vc-pagination/locale/ro_RO');

var _ro_RO2 = _interopRequireDefault(_ro_RO);

var _ro_RO3 = require('../date-picker/locale/ro_RO');

var _ro_RO4 = _interopRequireDefault(_ro_RO3);

var _ro_RO5 = require('../time-picker/locale/ro_RO');

var _ro_RO6 = _interopRequireDefault(_ro_RO5);

var _ro_RO7 = require('../calendar/locale/ro_RO');

var _ro_RO8 = _interopRequireDefault(_ro_RO7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  locale: 'ro',
  Pagination: _ro_RO2['default'],
  DatePicker: _ro_RO4['default'],
  TimePicker: _ro_RO6['default'],
  Calendar: _ro_RO8['default'],
  global: {
    placeholder: 'Selectează'
  },
  Table: {
    filterTitle: 'Filtrează',
    filterConfirm: 'OK',
    filterReset: 'Resetează',
    selectAll: 'Selectează pagina curentă',
    selectInvert: 'Inversează pagina curentă',
    sortTitle: 'Ordonează',
    expand: 'Extinde rândul',
    collapse: 'Micșorează rândul'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Anulare',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Anulare'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Căutare',
    itemUnit: 'element',
    itemsUnit: 'elemente'
  },
  Upload: {
    uploading: 'Se transferă...',
    removeFile: 'Înlătură fișierul',
    uploadError: 'Eroare la upload',
    previewFile: 'Previzualizare fișier',
    downloadFile: 'Descărcare fișier'
  },
  Empty: {
    description: 'Fără date'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'editează',
    copy: 'copiază',
    copied: 'copiat',
    expand: 'extinde'
  },
  PageHeader: {
    back: 'înapoi'
  }
};